import ResidentAbout from "./ResidentAbout";

export default ResidentAbout;